import { render, staticRenderFns } from "./PhotoelectricEffectViz.vue?vue&type=template&id=1fb88911&scoped=true"
import script from "./PhotoelectricEffectViz.vue?vue&type=script&lang=js"
export * from "./PhotoelectricEffectViz.vue?vue&type=script&lang=js"
import style0 from "./PhotoelectricEffectViz.vue?vue&type=style&index=0&id=1fb88911&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb88911",
  null
  
)

export default component.exports